module.exports = __webpack_public_path__ + "static/media/bg_img_p8.ecab3c32.png";